import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const DynamicFilterHeightContainer = styled.div<{ maxHeight: string | number }>`
  max-height: ${props => props.maxHeight}px;
  overflow-y: auto;
`;

type DynamicHeightPopoverContentProps = {
  children: React.ReactNode;
  isOpen: boolean;
};

const DynamicHeightPopoverContent = ({ children, isOpen }: DynamicHeightPopoverContentProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<string | number>('auto');
  const [initialRender, setInitialRender] = useState(true);

  const calculateMaximumContainerHeight = () => {
    if (containerRef.current) {
      const availableHeight = window.innerHeight - containerRef.current.getBoundingClientRect().top - 20;
      setMaxHeight(availableHeight);
    }
  };

  useEffect(() => {
    const handleResize = () => calculateMaximumContainerHeight();

    window.addEventListener('resize', handleResize);
    calculateMaximumContainerHeight();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (isOpen || initialRender) {
      calculateMaximumContainerHeight();
      setInitialRender(false);
    }
  }, [isOpen, initialRender]);

  return (
    <DynamicFilterHeightContainer ref={containerRef} maxHeight={maxHeight}>
      {children}
    </DynamicFilterHeightContainer>
  );
};

export default DynamicHeightPopoverContent;
